(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['module', 'jsonp', 'querystring'], factory);
  } else if (typeof exports !== "undefined") {
    factory(module, require('jsonp'), require('querystring'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, global.jsonp, global.querystring);
    global.request = mod.exports;
  }
})(this, function (module, jsonp, querystring) {
  'use strict';

  module.exports = function (config) {
    var url = config.url,
        _config$data = config.data,
        data = _config$data === undefined ? {} : _config$data,
        success = config.success,
        error = config.error,
        _config$callback = config.callback,
        callback = _config$callback === undefined ? 'callback' : _config$callback;

    var query = querystring.encode(data);
    jsonp(url + '?' + query, {
      param: callback,
      prefix: '__jp' + Math.floor(Math.random() * (10000 - 10 + 1) + 10)
    }, function (err, res) {
      if (err) {
        return error(err);
      } else {
        return success(res);
      }
    });
  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aliyun-business@1.0.30@@ali/aliyun-business/lib/util/request.js
// module id = 110
// module chunks = 0 1 2